// extracted by mini-css-extract-plugin
module.exports = {"TablePagination":"style_TablePagination__1KufO","button":"style_button__2Lqot"};